import { useEffect, useState } from 'react'
import SnackBar, { SnackBarProps } from '../../components/common/SnackBar'
import { MESSAGES } from '../constants'

export const useErrorHandlingSnackbar = () => {
    const messageTimeout = 5000
    const [snackBar, setSnackBar] = useState<SnackBarProps>({
        type: 'info',
        message: '',
    })

    const setSnackBarMessage = (
        message: unknown,
        type: SnackBarProps['type'] = 'error'
    ) => {
        let value = MESSAGES.error.endpointError
        if (typeof message === 'string') value = message
        else if (message instanceof Error) value = message.message

        setSnackBar({
            type,
            message: value,
        })
    }

    useEffect(() => {
        let timeout: ReturnType<typeof setTimeout>
        if (snackBar.message) {
            timeout = setTimeout(() => {
                setSnackBar({
                    type: 'info',
                    message: '',
                })
            }, messageTimeout)
        }
        return () => {
            clearTimeout(timeout)
        }
    }, [snackBar])

    const SnackBarDOM = (
        <SnackBar message={snackBar.message} type={snackBar.type} />
    )

    return { setSnackBarMessage, SnackBarDOM }
}
